import { UseFormReturn, FieldValues, Path, PathValue } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  NativeSelect,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import {
  FREQUENCY_OPTIONS,
  TIME_SELECT_OPTIONS,
  DAY_OF_WEEK_OPTIONS,
  DAY_OF_MONTH_OPTIONS,
} from "./scheduleUtils";

interface ScheduleFieldsProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  frequencyFieldName?: Path<T>;
  timeFieldName?: Path<T>;
  dayOfWeekFieldName?: Path<T>;
  dayOfMonthFieldName?: Path<T>;
}

export const ScheduleFields = <T extends FieldValues>({
  form,
  frequencyFieldName = "schedule_frequency" as Path<T>,
  timeFieldName = "schedule_time" as Path<T>,
  dayOfWeekFieldName = "schedule_day_of_week" as Path<T>,
  dayOfMonthFieldName = "schedule_day_of_month" as Path<T>,
}: ScheduleFieldsProps<T>) => {
  const scheduleFrequency = form.watch(frequencyFieldName) as PathValue<T, Path<T>>;

  return (
    <Stack direction="row">
      <FormField
        control={form.control}
        name={frequencyFieldName}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Update Frequency</FormLabel>
            <FormControl>
              <NativeSelect
                options={FREQUENCY_OPTIONS}
                value={field.value as string}
                onChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {scheduleFrequency === "weekly" && (
        <FormField
          control={form.control}
          name={dayOfWeekFieldName}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Day</FormLabel>
              <FormControl>
                <NativeSelect
                  options={DAY_OF_WEEK_OPTIONS}
                  value={field.value as string}
                  onChange={field.onChange}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {scheduleFrequency === "monthly" && (
        <FormField
          control={form.control}
          name={dayOfMonthFieldName}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Day</FormLabel>
              <FormControl>
                <NativeSelect
                  options={DAY_OF_MONTH_OPTIONS}
                  value={field.value as string}
                  onChange={field.onChange}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={form.control}
        name={timeFieldName}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Time (UTC)</FormLabel>
            <FormControl>
              <NativeSelect
                options={TIME_SELECT_OPTIONS}
                value={field.value as string}
                onChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </Stack>
  );
};
